import React, { useContext, useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import classes from "./Navbar.module.scss";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { FormControl, IconButton, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, OutlinedInput, Paper, Skeleton } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { DDD } from "../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useTranslation } from 'react-i18next';
import Button from "../UI/Button";
import BusinessIcon from '@mui/icons-material/Business';
import { ReactComponent as HQIcon } from "../../assets/headquarter.svg";
import GridOnIcon from '@mui/icons-material/GridOn';
import GridOffIcon from '@mui/icons-material/GridOff';
import StoreIcon from '@mui/icons-material/Store';
import LocationCityIcon from '@mui/icons-material/LocationCity';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const ChangeOrgModal = ({onHiddenChange, onAddNewCompany, reload, ...props}) => {
    const {isMaintainer} = useContext(OrgIdContext);
    const [search, setSearch] = useState();
    const { t } = useTranslation();
    const [showAll, setShowAll] = useState(false);
    
    
    const {isPending, data, refetch} = useQuery({
        queryKey: ['Auth.GetSessionInfo', ["Accounts"]],
        queryFn: () => ddd.Rpc_ExecuteMethod("Auth.GetSessionInfo", ["Accounts"]),
        staleTime: Infinity
    })

    useEffect(() => {
      if(!data?.result?.AuthorizedOrganizations || !onHiddenChange )
        return;
      
      for(let org of data?.result?.AuthorizedOrganizations){
        if(org.ClientType !== null && org.ClientType !== undefined) return onHiddenChange(true);

        if(org.ClientType === ClientTypes.ISV || org.ClientType === ClientTypes.AccService|| org.ClientType === ClientTypes.Company){
          onHiddenChange(true);
        }
      }
    }, [data, isPending]);

    useEffect(() =>{
      if(reload<2) return;
      refetch();
    }, [reload]);

    const changeOrganization =(id)=>{
        if(!id) return console.error("No id given for organization change");

        ddd.Rpc_ExecuteMethod("Auth.ChangeOrganization", [id]).then(() => {
            window.location.reload();
        });
    }

    const getOrgTypeIcon = (type) => {
      switch(type){
        case ClientTypes.ISV:
          return <BusinessIcon className={classes["org-type-icon"]} style={{color:"var(--main-blue)", fontSize:"2rem"}}/>
        case ClientTypes.AccService:
          return <LocationCityIcon className={classes["org-type-icon"]} style={{color:"var(--main-blue)", fontSize:"2rem"}}/>
        case ClientTypes.Company:
          return <LocationCityIcon className={classes["org-type-icon"]} style={{color:"var(--main-blue)", fontSize:"2rem"}}/>
        default:
          return <StoreIcon className={classes["org-type-icon"]} style={{color:"var(--main-blue)", fontSize:"2rem"}}/>
      }
    }

    return ( 
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          {...props}
        >
          <Modal.Header className={classes.modalHeader}>
            <div className='w-100 d-flex '>
                <div>
                  <CorporateFareIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/>
                  <span className={classes.modalTitleText}>{t("Change organization")}</span>
                </div>
                <div className="ms-auto">
                  <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}}  onClick={props.onHide} />
                </div>
              </div>
          </Modal.Header>
          <Modal.Body >
            <div className="d-flex">
              <Paper component="form" onSubmit={(e) => {e.preventDefault();}}  sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', flexGrow:1}}>
                  <InputBase sx={{ ml: 1, flex: 1 }}
                      placeholder={t("Search organization")}
                      inputProps={{ 'aria-label': 'Search organization' }}
                      value={search}
                      fullWidth 
                      onChange={(e) => {setSearch(e.target.value)}}
                  />
                  <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                      <SearchIcon />
                  </IconButton>
              </Paper>
              
              <Button style={{marginLeft:"1rem", height:"2.3rem"}} onClick={onAddNewCompany}>
                <PersonAddIcon/>
              </Button>
              {isMaintainer && <Button style={{marginLeft:"1rem", height:"2.3rem"}} onClick={() => setShowAll(!showAll)}>
                {showAll && <GridOnIcon/>}
                {!showAll && <GridOffIcon/>}
              </Button>
              }
            </div>
            <div className={classes.modalBody}>
                    {!data?.result?.AuthorizedOrganizations && [...Array(50)].map((i, index) => {
                        return(<div key={"skelly-"+index}><Skeleton style={{height:"55px"}}/></div>)
                    })}
                    {data?.result?.AuthorizedOrganizations && 
                    <List sx={{ width: '100%', bgcolor: '' }}>
                        {data?.result?.AuthorizedOrganizations.map((item, index) => {
                            if((item.ClientType === null || item.ClientType === undefined || item.IsCustomer===true) && !showAll) return null;
                            //if(item.IsCustomer && !showAll) return null;
                            //if((item.ClientType === null || item.ClientType === undefined) && !showAll) return null;
                            /*if(item.ClientType !== ClientTypes.ISV && item.ClientType!==ClientTypes.AccService && item.ClientType!==ClientTypes.Company)
                              return null;*/
                            if(search && search.trim() !=="" && item.Title.toLocaleLowerCase().indexOf(search.trim().toLocaleLowerCase())<0 && item.VatNo.toLocaleLowerCase().indexOf(search.trim().toLocaleLowerCase())<0)
                              return null;
                            return(
                            <ListItem key={"list-"+index} className={classes["org-list-item"]} onClick={() => {changeOrganization(item.Id)}} /* secondaryAction={getOrgTypeIcon(item.ClientType)} */>
                                {isMaintainer && getOrgTypeIcon(item.ClientType)}
                                <ListItemText primary={item.Title} secondary={item.VatNo} />
                            </ListItem>
                            )
                        })}
                    </List>
                    }
            </div>
          </Modal.Body>
        </Modal>
      );
};

export default ChangeOrgModal;